var MultiGeometryViewBase = require('../base/multi-geometry-view-base');
var Pointview = require('./point-view');

var MultiPolygonView = MultiGeometryViewBase.extend({
  GeometryViewClass: Pointview
});

module.exports = MultiPolygonView;



//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/geo/geometry-views/gmaps/multi-point-view.js
// module id = 1626
// module chunks = 6